import axios from "../../utils/axios";

export const getJobs = async (text) => {
    let queryParams = "";

    if (text.length > 0) {
        queryParams += `title_like=${text}`;
    }

    const response = await axios.get(`/jobs?${queryParams}`);
    return response.data;
};

export const getSingleJob = async (jobId) => {
    const response = await axios.get(`/jobs/${jobId}`);
    return response.data;
};

export const createJob = async (data) => {
    const response = await axios.post("/jobs", data);
    return response.data;
};

export const updateJob = async (id, data) => {
    const response = await axios.patch(`/jobs/${id}`, data);
    return response.data;
};

export const deleteJob = async (jobId) => {
    const response = await axios.delete(`/jobs/${jobId}`);
    return response.data;
};
